import * as angular from 'angular';
import { resolve } from '../../../../../init/store';

export class Controller {

    /** @ngInject */
    constructor(Alert, ConfirmDeleteModal, SharedAccountsService,$state) {
        this.Alert = Alert;
        this.ConfirmDeleteModal = ConfirmDeleteModal;
        this.SharedAccountsService = SharedAccountsService;
        this.$state=$state;
    }

    $onInit() {
	this.theNote=this.sharedAccount;
		if(this.theNote==null){
			 this.$state.go('^');
		}
        this.note = {...this.theNote};
    }

    notModified() {
        return angular.equals(this.note, this.theNote);
    }

    remove() {
        this.isRemoving = true;
        this.ConfirmDeleteModal('company.sharing-center.confirm_company_note_delete')
            .then(() => this.SharedAccountsService.deleteNote({
                companyId: this.companyId,
                id: this.note.id,
            }).$promise)
            .then(() => {
                this.$state.go('^.^', {}, { reload: '^.^' });
                this.Alert('success', 'company.sharing-center.note.manage.removed');
            })
            .finally(() => this.isRemoving = false)
    }

    save() {
		this.isSaving = true;
        this.SharedAccountsService.updateNote(
            {
                companyId: this.note.company.id,
                id: this.note.id,
            },
            this.note
        )
            .$promise
            .then(note => {
                this.$state.go('^.^', {}, { reload: '^.^' });
                this.Alert('success', 'company.sharing-center.note.manage.saved');
            })
            .finally(() => this.isSaving = false)
       
    }

    saveDisabled(form) {
        return this.isSaving || form.$invalid || this.notModified();
    }
}

function generatePublicServiceKey(issuer, username, secretKey, digits, algorithm) {
    const secret = secretKey.replace(/\s/g, '');
    return `otpauth://totp/${issuer}:${username}?secret=${secret}&issuer=${issuer}&digits=${digits}&algorithm=${algorithm}`;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-notes/manage/manage-shared-note.controller.js